var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { GameLevel, GameStatus, GameUserRole, GameUserStatus, } from "@/store/api";
import { DATE_SERV_FORMAT } from "@/tools/constants";
import { parseEmptyNumberToUndefined } from "@/tools/parse";
export var convertToGameUserUpdateDto = function (data) {
    return {
        status: data.status[0] || GameUserStatus.Invited,
        role: data.role || GameUserRole.Member,
        userId: data.userId,
        userName: data.userName,
    };
};
export var convertToGameUpdateDto = function (data) {
    var _mata = data.meta, level = data.level, placeId = data.placeId, sportId = data.sportId, date = data.date, gameUsers = data.gameUsers, countMembersMax = data.countMembersMax, countMembersMin = data.countMembersMin, rest = __rest(data, ["meta", "level", "placeId", "sportId", "date", "gameUsers", "countMembersMax", "countMembersMin"]);
    var dtoData = __assign(__assign({}, rest), { placeId: placeId[0], sportId: sportId[0], date: date.format(DATE_SERV_FORMAT), gameUsers: gameUsers.map(convertToGameUserUpdateDto) || [], status: GameStatus.Aproved, level: level[0] || GameLevel.Easy, countMembersMax: parseEmptyNumberToUndefined(countMembersMax), countMembersMin: parseEmptyNumberToUndefined(countMembersMin), requestMode: data.requestMode });
    return dtoData;
};
/**
 * Объединяет данные шага 1, шага 2 и оригинальные данные в полную модель игры
 * @param originalData - оригинальные данные игры
 * @param step1Data - данные первого шага (площадка, дата, время)
 * @param step2Data - данные второго шага (остальные поля)
 * @returns полная модель игры
 */
export var mergeStepDataToViewModel = function (originalData, step1Data, step2Data) {
    return __assign(__assign(__assign({}, originalData), step2Data), { placeId: step1Data.placeId, date: step1Data.date, timeStart: step1Data.timeStart, timeEnd: step1Data.timeEnd });
};
